import axios from "axios";

export function businessErrorCode(err: unknown): string | undefined {
  if (axios.isAxiosError(err) && err.response?.status === 413) {
    return "TICKET_PAYLOAD_TOO_LARGE";
  }
  const data = axios.isAxiosError(err) ? err.response?.data : undefined;
  const raw = data?.response?.businessErrorCode ?? data?.businessErrorCode;
  if (typeof raw === "string") return raw;
  if (raw && typeof raw === "object" && typeof raw.code === "string") return raw.code;
  return undefined;
}

export function apiMessage(err: unknown): string | undefined {
  if (!axios.isAxiosError(err)) return undefined;
  const data = err.response?.data as { message?: string; response?: { message?: string } } | undefined;
  return data?.message || data?.response?.message || err.message;
}
